var moduleMap = {
	"./pages-map": function() {
		return __webpack_require__.e(/* __federation_expose_pages_map */ 2019).then(function() { return function() { return (__webpack_require__(6414)); }; });
	},
	"./pages-map-v2": function() {
		return __webpack_require__.e(/* __federation_expose_pages_map_v2 */ 3974).then(function() { return function() { return (__webpack_require__(3419)); }; });
	},
	"./pages/index": function() {
		return Promise.all(/* __federation_expose_pages__index */[__webpack_require__.e(3227), __webpack_require__.e(5724), __webpack_require__.e(5786), __webpack_require__.e(7814)]).then(function() { return function() { return (__webpack_require__(4780)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope, remoteEntryInitOptions) {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});